import Vue from 'vue'
import Vuex from 'vuex'
import Vconsole from 'vconsole'
import baseUrl from './api/baseUrl'
Vue.use(Vuex)

const UserInfo = sessionStorage.getItem("userInfo")
if (UserInfo) {
	//白名单id添加开发者工具
	if (JSON.parse(UserInfo).is_debug) new Vconsole();
}
export default new Vuex.Store({
	state: {
		userInfo: UserInfo ? JSON.parse(UserInfo) : '',
		token: "",
		is_new: 0,		// 是否新用户
	},
	mutations: {
		setUserInfo: (state, info) => {
			info.is_student = ['is_worker', 'is_dst', 'is_agent'].some(e => Number(info[e])==1) ? false : 1
			info.is_dst=info.is_dst==1?1:false
			info.is_worker=info.is_worker==1?1:false
			info.is_agent=info.is_agent==1?1:false
			sessionStorage.setItem('userInfo', JSON.stringify(info))
			state.userInfo = info
			state.is_new = info.is_new
			//白名单id添加开发者工具
			if (info.is_debug) new Vconsole();
		}
	},
	actions: {

	}
})